import { create } from 'zustand';

export type PhoneLegJob = {
  rowId: string;
  match: string;
  source: string;
  book: string;
  index: 1 | 2 | 3;
  stake: string;
  odds: string;
  promised: string;
};

type PhoneQueue = {
  jobs: PhoneLegJob[];
  toast: string;
  webOnly: boolean;
  push: (jobs: PhoneLegJob[]) => void;
  shift: () => PhoneLegJob | undefined;
  clear: () => void;
  say: (text: string) => void;
  setWebOnly: (on: boolean) => void;
};

export const usePhoneQueue = create<PhoneQueue>((set, get) => ({
  jobs: [],
  toast: '',
  webOnly: false,
  push: (jobs) => set({ jobs: [...get().jobs, ...jobs] }),
  shift: () => {
    const [head, ...rest] = get().jobs;
    set({ jobs: rest });
    return head;
  },
  clear: () => set({ jobs: [] }),
  say: (text) => {
    set({ toast: text });
    window.setTimeout(() => {
      if (get().toast === text) set({ toast: '' });
    }, 2200);
  },
  setWebOnly: (on) => set({ webOnly: on }),
}));
